import React, { useRef } from 'react'
import { ILightRailItem } from '../../../types'
import { HiddenItem, ProgramSeriesWrapClip } from './ProgramSeries.style'
import { useProgramContext } from './ProgramContext'
import { EpisodeListItemClip } from './EpisodeListItemClip'
import { ClipPageBetweenEpisodesWidget } from '../../AdsComponents'

interface ProgramItemProps {
  additionalSeries?: ILightRailItem[] | null
  taboolaCounter: number
  visibleRows: number
  itemsPerRow: number
  currentAssetId: number
  isActiveTab: boolean
  taboolaWidgetCounter: number
  bigImage?: boolean
}

export const ProgramSeriesClip: React.FC<ProgramItemProps> = ({
  additionalSeries,
  visibleRows,
  itemsPerRow,
  currentAssetId,
  isActiveTab,
  taboolaWidgetCounter,
  bigImage,
}) => {
  const container = useRef<HTMLDivElement>(null)
  const { program, seasonNumber } = useProgramContext()
  const maxVisibleItems = visibleRows * itemsPerRow

  if (!additionalSeries || additionalSeries.length === 0) {
    return null
  }

  return (
    <ProgramSeriesWrapClip
      ref={container}
      key={['ProgramSeriesWrap', program.id, seasonNumber, isActiveTab].join(
        '_'
      )}
    >
      {additionalSeries
        .filter(series => currentAssetId !== series.id)
        .slice(0, maxVisibleItems)
        .map((railItem, i) => (
          <React.Fragment key={railItem.id}>
            <EpisodeListItemClip
              data={railItem}
              isLast={i === additionalSeries.length - 1}
              bigImage={bigImage}
            />
            {i === 4 && (
              <ClipPageBetweenEpisodesWidget
                taboolaWidgetCounter={taboolaWidgetCounter}
                key='between-widget'
              />
            )}
          </React.Fragment>
        ))}

      {additionalSeries
        .filter(serie => currentAssetId !== serie.id)
        .slice(maxVisibleItems)
        .map(railItem => (
          <HiddenItem
            className='hidden-ep'
            key={'hidden_' + railItem.id}
            data-name={railItem.name}
          />
        ))}
    </ProgramSeriesWrapClip>
  )
}
